// extracted by mini-css-extract-plugin
export var changeIcon = "_5e-4";
export var clickable = "_5e-8";
export var container = "_5e-0";
export var divider = "_5e-7";
export var externalLinkIcon = "_5e-1";
export var green = "_5e-5";
export var helpCircleIcon = "_5e-3";
export var iconButton = "_5e-2";
export var red = "_5e-6";